import React, { ReactElement } from "react";
import { Box, Button, Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: 7.75,
  },
}));
interface Props {
  onClick: any;
  children: any;
  isGreen?: any;
  disable?: boolean;
  primary?: boolean;
}

export default function CommonButtonOutLined({
  onClick,
  children,
  isGreen = false,
  disable = false,
  primary,
}: Props): ReactElement {
  const classes = useStyles();
  return (
    <Box component="span" mr={1} mb={1}>
      <Button
        className={classes.button}
        variant="outlined"
        color={primary ? "primary" : isGreen ? "secondary" : "inherit"}
        size="small"
        component="label"
        onClick={onClick}
        disabled={disable}
        disableElevation
      >
        {children}
      </Button>
    </Box>
  );
}
